import React, { useState, useEffect } from 'react';
import { statsAPI } from '../services/api';

const Stats = () => {
  const [stats, setStats] = useState({
    totalClients: 500,
    yearsExperience: 15,
    satisfactionRate: 100
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await statsAPI.get();
        if (response.success) {
          setStats(response.data);
        }
      } catch (error) {
        console.error('Erreur chargement stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="text-center animate-pulse">
                <div className="h-16 bg-gray-300 rounded mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto"></div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-5xl lg:text-6xl font-bold gradient-text mb-2 stat-number">
              {stats.totalClients}+
            </div>
            <p className="text-gray-600 font-medium">Clients satisfaits</p>
          </div>
          <div className="text-center">
            <div className="text-5xl lg:text-6xl font-bold gradient-text mb-2 stat-number delay-100">
              {stats.yearsExperience}
            </div>
            <p className="text-gray-600 font-medium">Ans d'expérience</p>
          </div>
          <div className="text-center">
            <div className="text-5xl lg:text-6xl font-bold gradient-text mb-2 stat-number delay-200">
              24/7
            </div>
            <p className="text-gray-600 font-medium">Disponibilité</p>
          </div>
          <div className="text-center">
            <div className="text-5xl lg:text-6xl font-bold gradient-text mb-2 stat-number delay-300">
              {stats.satisfactionRate}%
            </div>
            <p className="text-gray-600 font-medium">Satisfaction garantie</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
